<template>
  <div
    v-if="visible"
    class="paginated-stream-container tw:flex tw:flex-1 tw:flex-col tw:min-h-0"
    data-testid="paginated-stream-container"
  >
    <div class="tw:flex-1 tw:overflow-y-auto tw:min-h-0">
      <SkeletonMentionStream v-if="loading && showSkeleton" />

      <slot v-else />
    </div>

    <div
      v-if="!loading && pagination.pageCount > 1 && !hidePaginationControls"
      class="tw:flex tw:justify-center tw:border-t tw:border-denim-200 tw:bg-white tw:shrink-0 tw:py-3"
      data-testid="paginated-stream-container-footer"
    >
      <BasePagination
        hide-page-size-options
        :pagination="pagination"
        @pagination-changed="emit('paginationChanged', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { BasePaginationData } from "shared/components/base/BasePagination";
import BasePagination from "shared/components/base/BasePagination";
import SkeletonMentionStream from "shared/components/SkeletonMentionStream.vue";

interface PaginatedStreamContainerProps {
  hidePaginationControls?: boolean;
  loading: boolean;
  pagination: BasePaginationData;
  showSkeleton?: boolean;
  visible?: boolean;
}

interface PaginatedStreamContainerEmits {
  paginationChanged: [BasePaginationData];
}

defineProps<PaginatedStreamContainerProps>();

const emit = defineEmits<PaginatedStreamContainerEmits>();
</script>
